// Calendly link for the founder installation call (BIO-2156), with the tracking
// app's generateCalendlyParameters sends, so task-service ties the booking to the
// company (BIO-2387). utm_content is positional:
//   companyId|userId|source|callKind|scheduledByUserId|prevEventUuid|sfRecordId
// task-service skips any booking whose utm_term isn't `<app>|<env>`
// (UTM_TERM_PATTERN in scheduler.service.ts accepts app, honey, www and get).

export const FOUNDER_CALL_KIND = 'founder-installation';

/**
 * @param {string} [base] Calendly event URL, empty when not configured.
 * @param {object} lead name, email, company and phone prefill, plus the ids.
 * @param {string} [env] the ENV this build runs in, e.g. "production".
 * @returns {string} the booking URL, or '' without an event URL.
 */
export const buildFounderCallUrl = (
  base,
  { fullName, email, companyName, phone, companyId, userId },
  env
) => {
  if (!base) {
    return '';
  }

  const params = new URLSearchParams({
    name: fullName || '',
    email: email || '',
    a1: companyName || '',
    a2: phone || '',
    utm_source: 'get',
    utm_content: [
      companyId,
      userId,
      '',
      FOUNDER_CALL_KIND,
      userId,
      '',
      '',
    ].join('|'),
    utm_term: `get|${env}`,
  });

  return `${base}?${params}`;
};
